module.exports = __webpack_public_path__ + "media/accident.3da50b04.wav";